import * as yup from 'yup';

export const feedbackSchema = yup.object().shape({
  feedbackSubject: yup.string().required('Subject is required'),
  feedbackType: yup.string().required('Type is required'),
  feedbackDetail: yup.string().required('Detail is required'),
  moduleName: yup.string().optional()
});

export type FeedbackFormData = yup.InferType<typeof feedbackSchema>;
